import { useMemo } from 'react'
import { Tabs, Space } from 'antd'

import styles from './ProfileUser.module.scss'
import useStore from 'base/store'
import { isProjectRequest, hasOverdueConditions } from 'modules/project'
import { useGetNotifications, useGetConditions } from 'common/api'
import { Circle } from 'common/components'

const ProfileUser = () => {
  const { data: notifications } = useGetNotifications()
  const { data: conditions } = useGetConditions()
  const coordinatorTabKey = useStore((state) => state.coordinatorTabKey)
  const setCoordinatorTabKey = useStore((state) => state.setCoordinatorTabKey)
  const role = useStore((state) => state.role)

  const tabItems = useMemo(() => {
    const requestUpdatesCount = notifications?.filter((notification: any) =>
      isProjectRequest(notification.data.project)
    ).length
    const projectUpdatesCount = notifications?.filter(
      (notification: any) => !isProjectRequest(notification.data.project)
    ).length

    const baseTabsItems = [
      {
        key: 'request',
        label: (
          <>
            Request updates<span className={styles.spacer}>•</span>
            {requestUpdatesCount}
          </>
        ),
      },
      {
        key: 'project',
        label: (
          <>
            Project updates<span className={styles.spacer}>•</span>
            {projectUpdatesCount}
          </>
        ),
      }
    ];

    return (role.coordinator || role.manager) ? [...baseTabsItems, {
      key: 'condition',
      label: hasOverdueConditions(conditions) ? (
        <Space size={6}>
          <span>Conditions</span>
          <Circle ripple color="red" />
        </Space>
      ) : (
        'Conditions'
      ),
    }] : baseTabsItems;
  }, [conditions, notifications, role.coordinator, role.manager]);

  return (
    <div className={styles.root}>
      <Tabs
        className={styles.tabs}
        activeKey={coordinatorTabKey}
        items={tabItems}
        onChange={setCoordinatorTabKey}
      />
    </div>
  )
}

export default ProfileUser;